import { render, staticRenderFns } from "./SitePluginEdit.vue?vue&type=template&id=03c3ad3c&scoped=true&"
import script from "./SitePluginEdit.vue?vue&type=script&lang=js&"
export * from "./SitePluginEdit.vue?vue&type=script&lang=js&"
import style0 from "./SitePluginEdit.vue?vue&type=style&index=0&id=03c3ad3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c3ad3c",
  null
  
)

export default component.exports